
































































import Vue from "vue";
import { mapState } from "vuex";
import { ItemConditionOptions, SampleOptionItems } from "../../types";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {
      isSampleOptionOpen: false,
    };
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState("appModule", {
      user: "loggedInUser",
    }),
    sampleActionItems() {
      return SampleOptionItems;
    },
  },
  inject: ["actionHandler"],
  methods: {
    handleTableClick(type: "request" | "edit") {
      this.actionHandler(type, this.row);
      this.isSampleOptionOpen = false;
    },
  },
});
